__turbopack_context__.v({
  "button": "yUwXuG_button",
  "root": "yUwXuG_root",
});
